var _path, _g, _path2, _g2, _path3, _path4, _rect, _path5, _rect2, _g3, _path6, _g4, _path7, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1233,
    height: 2487,
    viewBox: "0 0 1233 2487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.587 0C377.28 0 876.104 0 1004.61 0C1133.11 0 1233 51.2833 1233 224.53C1233 499.308 1233 2140.71 1233 2233.21C1233 2325.71 1228.55 2486.36 1016.05 2486.36C803.55 2486.36 286.083 2486.36 193.411 2486.36C100.739 2486.36 0 2430.5 0 2272.01C0 2113.53 0 386.725 0 224.53C0 39.6269 115.539 0 224.587 0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.867 180.005C896.053 180.641 915.89 140.563 916.418 112.583C916.418 97.7416 920.696 92.8649 937.42 92.8649C954.144 92.8649 978.804 92.8649 1034.16 92.8649C1089.52 92.8649 1153.17 118.307 1153.17 216.261C1153.17 314.214 1153.17 2226.22 1153.17 2305.09C1153.17 2383.96 1111.16 2428.48 1017.61 2428.48C924.055 2428.48 293.978 2428.48 198.528 2428.48C103.077 2428.48 73.1656 2370.6 73.1656 2306.99C73.1656 2243.39 73.1656 289.408 73.1656 209.264C73.1656 129.12 130.443 92.2289 183.902 92.2289C237.361 92.2289 276.183 92.2289 291.457 92.2289C306.731 92.2289 309.913 101.134 309.913 111.311C309.913 121.488 315.403 178.942 378.646 179.369C432.105 179.369 790.408 180.005 850.867 180.005Z",
    fill: "#F7F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 92,
    width: 1081,
    height: 2337
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.867 180.005C896.053 180.641 915.89 140.563 916.418 112.583C916.418 97.7416 920.696 92.8649 937.42 92.8649C954.144 92.8649 978.804 92.8649 1034.16 92.8649C1089.52 92.8649 1153.17 118.307 1153.17 216.261C1153.17 314.214 1153.17 2226.22 1153.17 2305.09C1153.17 2383.96 1111.16 2428.48 1017.61 2428.48C924.055 2428.48 293.978 2428.48 198.528 2428.48C103.077 2428.48 73.1656 2370.6 73.1656 2306.99C73.1656 2243.39 73.1656 289.408 73.1656 209.264C73.1656 129.12 130.443 92.2289 183.902 92.2289C237.361 92.2289 276.183 92.2289 291.457 92.2289C306.731 92.2289 309.913 101.134 309.913 111.311C309.913 121.488 315.403 178.942 378.646 179.369C432.105 179.369 790.408 180.005 850.867 180.005Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.814 2387.77H802.913C808.535 2387.77 813.093 2392.33 813.093 2397.95C813.093 2403.57 808.535 2408.13 802.913 2408.13H428.814C423.192 2408.13 418.635 2403.57 418.635 2397.95C418.635 2392.33 423.192 2387.77 428.814 2387.77Z",
    fill: "#F0F3F5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.85 143.75H1051.04C1046.12 143.75 1042.13 147.737 1042.13 152.655V167.92C1042.13 172.838 1046.12 176.825 1051.04 176.825H1096.85C1101.77 176.825 1105.76 172.838 1105.76 167.92V152.655C1105.76 147.737 1101.77 143.75 1096.85 143.75ZM1044.68 152.655C1044.68 149.142 1047.53 146.294 1051.04 146.294H1096.85C1100.36 146.294 1103.21 149.142 1103.21 152.655V167.92C1103.21 171.433 1100.36 174.281 1096.85 174.281H1051.04C1047.53 174.281 1044.68 171.433 1044.68 167.92V152.655Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1047.22,
    y: 148.838,
    width: 53.4427,
    height: 22.8982,
    rx: 3.81619,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1109.57 165.216C1111.77 164.651 1113.39 162.659 1113.39 160.287C1113.39 157.916 1111.77 155.924 1109.57 155.359V165.216Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 964,
    y: 92,
    width: 86,
    height: 86
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 964.519,
    y: 135.148,
    width: 59.805,
    height: 59.7898,
    transform: "rotate(-45 964.519 135.148)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1006.8,
    cy: 177.426,
    rx: 11.452,
    ry: 11.4491,
    transform: "rotate(-45 1006.8 177.426)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.403 200.82C996.32 213.736 1017.26 213.734 1030.18 200.814C1043.1 187.894 1043.11 166.949 1030.19 154.032C1017.27 141.116 996.329 141.118 983.409 154.038C970.489 166.958 970.487 187.903 983.403 200.82ZM1024.79 159.431C1034.73 169.367 1034.73 185.478 1024.79 195.416C1014.85 205.355 998.738 205.357 988.802 195.421C978.866 185.485 978.868 169.374 988.807 159.435C998.745 149.497 1014.86 149.495 1024.79 159.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.501 192.722C999.947 201.167 1013.64 201.166 1022.09 192.718C1030.54 184.27 1030.54 170.576 1022.09 162.13C1013.65 153.685 999.953 153.686 991.505 162.134C983.057 170.582 983.056 184.276 991.501 192.722ZM1017.59 166.629C1023.56 172.59 1023.55 182.257 1017.59 188.22C1011.63 194.183 1001.96 194.184 996 188.223C990.038 182.261 990.04 172.595 996.003 166.632C1001.97 160.669 1011.63 160.667 1017.59 166.629Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.059 145.022H961.969C960.564 145.022 959.424 146.161 959.424 147.566V174.281C959.424 175.686 960.564 176.825 961.969 176.825H967.059C968.464 176.825 969.604 175.686 969.604 174.281V147.566C969.604 146.161 968.464 145.022 967.059 145.022ZM947.972 151.383H953.062C954.467 151.383 955.607 152.522 955.607 153.927V174.281C955.607 175.686 954.467 176.825 953.062 176.825H947.972C946.567 176.825 945.427 175.686 945.427 174.281V153.927C945.427 152.522 946.567 151.383 947.972 151.383ZM939.065 157.743H933.975C932.57 157.743 931.43 158.882 931.43 160.288V174.281C931.43 175.686 932.57 176.825 933.975 176.825H939.065C940.47 176.825 941.61 175.686 941.61 174.281V160.288C941.61 158.882 940.47 157.743 939.065 157.743ZM925.068 164.104H919.978C918.573 164.104 917.433 165.243 917.433 166.648V174.281C917.433 175.686 918.573 176.825 919.978 176.825H925.068C926.474 176.825 927.613 175.686 927.613 174.281V166.648C927.613 165.243 926.474 164.104 925.068 164.104Z",
    fill: "black"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.864,
    cy: 153.927,
    rx: 3.81734,
    ry: 3.81637,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.864,
    cy: 169.192,
    rx: 3.81734,
    ry: 3.81637,
    fill: "black"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.788 108.13H677.577C683.551 108.13 688.393 112.972 688.393 118.943C688.393 124.915 683.551 129.757 677.577 129.757H547.788C541.815 129.757 536.972 124.915 536.972 118.943C536.972 112.972 541.815 108.13 547.788 108.13Z",
    fill: "#F0F3F5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 745.653,
    cy: 118.307,
    rx: 17.8142,
    ry: 17.8097,
    fill: "#F0F3F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_2",
    x: 71.1656,
    y: 90.2289,
    width: 1084,
    height: 2340.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.0712,
    height: 63.6061,
    fill: "white",
    transform: "translate(170.508 129.757)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.afe1f557e9b60d49785ba4c285b72962.svg";
export { ForwardRef as ReactComponent };